const { on, trigger } = window.ivent;
const { documentElement } = document;

const events = {
	collapsed: 'aspect.sidebar.collapsed',
	open: 'aspect.sidebar.open',
};

// Collapse sidebar.
on(document, 'click', '.toggle-sidebar', (e) => {
	e.preventDefault();

	const hasCollapsed =
		documentElement.getAttribute('data-sidebar-collapsed') === 'true';

	// Set attribute.
	documentElement.setAttribute('data-sidebar-collapsed', !hasCollapsed);

	// Set local storage.
	localStorage.setItem('sidebar-collapsed', !hasCollapsed);

	// Set event.
	trigger(document, hasCollapsed ? events.collapsed : events.open);
});

const resizeObserver = new ResizeObserver((entries, observer) => {
	entries.forEach((entry) => {
		trigger(
			document,
			entry.target.clientWidth < 200 ? events.collapsed : events.open,
		);
	});
});

resizeObserver.observe(document.querySelector('.sidebar'));
